// Structured Data for different types of pages

export const LocalBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://maasaryuagency.com/#localbusiness",
  "name": "Maa Saryu Agency",
  "alternateName": ["Maa Saryu Tiles", "Saryu Agency"],
  "description": "Leading supplier of premium tiles, granite, CP fittings, bath fittings, and sanitary ware in Ayodhya. Wholesale & retail solutions for homes and businesses with 15+ years experience.",
  "url": "https://maasaryuagency.com",
  "logo": "https://maasaryuagency.com/logo512.jpg",
  "image": [
    "https://maasaryuagency.com/logo512.jpg",
    "https://maasaryuagency.com/images/showroom_image.png"
  ],
  "telephone": ["+917897239423", "+919651245787"],
  "email": "maasaryuagency@gmail.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Ashapur Rd, Darshan Nagar, Devkali Bypass Road",
    "addressLocality": "Ayodhya",
    "addressRegion": "Uttar Pradesh",
    "postalCode": "224135",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 26.7922,
    "longitude": 82.1998
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      "opens": "09:00",
      "closes": "19:00"
    }
  ],
  "priceRange": "$$",
  "currenciesAccepted": "INR",
  "paymentAccepted": ["Cash", "Credit Card", "UPI", "Bank Transfer"],
  "areaServed": {
    "@type": "City",
    "name": "Ayodhya",
    "containedInPlace": {
      "@type": "State",
      "name": "Uttar Pradesh",
      "containedInPlace": {
        "@type": "Country",
        "name": "India"
      }
    }
  },
  "serviceArea": {
    "@type": "GeoCircle",
    "geoMidpoint": {
      "@type": "GeoCoordinates",
      "latitude": 26.7922,
      "longitude": 82.1998
    },
    "geoRadius": "50000"
  },
  "category": ["Building Materials", "Tiles", "Sanitary Ware", "Home Improvement"],
  "keywords": "tiles, granite, sanitary ware, CP fittings, bath fittings, ceramic tiles, porcelain tiles, marble, bathroom accessories, kitchen fittings, wholesale, retail",
  "founder": {
    "@type": "Person",
    "name": "Maa Saryu Agency Founder"
  },
  "foundingDate": "2009",
  "numberOfEmployees": "10-20",
  "slogan": "Premium Quality, Trusted Service",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "324"
  },
  "review": [
    {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5"
      },
      "author": {
        "@type": "Person",
        "name": "Customer Review"
      },
      "reviewBody": "Excellent quality tiles and professional service. Highly recommended for home renovation projects."
    }
  ],
  "makesOffer": [
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Tile Installation & Supply",
        "description": "Professional tile installation and supply services"
      }
    },
    {
      "@type": "Offer", 
      "itemOffered": {
        "@type": "Product",
        "name": "Premium Tiles & Sanitary Ware",
        "description": "Wide range of premium tiles, granite, and sanitary ware products"
      }
    }
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Maa Saryu Agency Product Catalog",
    "itemListElement": [
      {
        "@type": "OfferCatalog",
        "name": "Floor Tiles",
        "description": "Premium ceramic, porcelain, and marble floor tiles"
      },
      {
        "@type": "OfferCatalog", 
        "name": "Wall Tiles",
        "description": "Decorative and functional wall tiles for kitchens and bathrooms"
      },
      {
        "@type": "OfferCatalog",
        "name": "Granite",
        "description": "Natural granite slabs and tiles for countertops and flooring"
      },
      {
        "@type": "OfferCatalog",
        "name": "Sanitary Ware", 
        "description": "Modern toilets, basins, and bathroom fixtures"
      },
      {
        "@type": "OfferCatalog",
        "name": "CP Fittings",
        "description": "Chrome plated taps, faucets, and bathroom fittings"
      },
      {
        "@type": "OfferCatalog",
        "name": "Bath Accessories",
        "description": "Complete range of bathroom accessories and fittings"
      }
    ]
  },
  "sameAs": [
    "https://www.facebook.com/profile.php?id=61558632194566",
    "https://instagram.com/maasaryuagency"
  ]
};

export const WebsiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://maasaryuagency.com/#website",
  "name": "Maa Saryu Agency",
  "url": "https://maasaryuagency.com",
  "description": "Premium tiles, granite, and sanitary solutions in Ayodhya",
  "publisher": {
    "@id": "https://maasaryuagency.com/#localbusiness"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://maasaryuagency.com/gallery?search={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export const OrganizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://maasaryuagency.com/#organization",
  "name": "Maa Saryu Agency",
  "url": "https://maasaryuagency.com",
  "logo": "https://maasaryuagency.com/logo512.jpg",
  "description": "Leading supplier of premium tiles, granite, and sanitary ware in Ayodhya",
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+917897239423",
      "contactType": "sales",
      "availableLanguage": ["Hindi", "English"],
      "areaServed": "IN"
    },
    {
      "@type": "ContactPoint", 
      "telephone": "+919651245787",
      "contactType": "customer service",
      "availableLanguage": ["Hindi", "English"],
      "areaServed": "IN"
    }
  ],
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Ashapur Rd, Darshan Nagar, Devkali Bypass Road",
    "addressLocality": "Ayodhya",
    "addressRegion": "Uttar Pradesh", 
    "postalCode": "224135",
    "addressCountry": "IN"
  },
  "sameAs": [
    "https://www.facebook.com/profile.php?id=61558632194566",
    "https://instagram.com/maasaryuagency"
  ]
};

export const BreadcrumbSchema = (items: Array<{name: string, url: string}>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `https://maasaryuagency.com${item.url}`
  }))
});

export const ProductSchema = (product: {
  name: string;
  description: string;
  category: string;
  image?: string;
  price?: string;
  availability?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": product.name,
  "description": product.description,
  "category": product.category,
  "image": product.image || "https://maasaryuagency.com/logo512.jpg",
  "brand": {
    "@type": "Brand",
    "name": "Maa Saryu Agency"
  },
  "manufacturer": {
    "@type": "Organization",
    "name": "Maa Saryu Agency"
  },
  "offers": {
    "@type": "Offer",
    "price": product.price || "Contact for Price",
    "priceCurrency": "INR",
    "availability": product.availability === "In Stock" ? 
      "https://schema.org/InStock" : "https://schema.org/PreOrder",
    "seller": {
      "@type": "Organization",
      "name": "Maa Saryu Agency"
    }
  }
});

export const ServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Tile Installation and Supply Services",
  "description": "Professional tile installation, granite fitting, and sanitary ware installation services in Ayodhya",
  "provider": {
    "@id": "https://maasaryuagency.com/#localbusiness"
  },
  "serviceType": "Home Improvement",
  "areaServed": {
    "@type": "City",
    "name": "Ayodhya"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Installation Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Tile Installation",
          "description": "Professional floor and wall tile installation"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service", 
          "name": "Granite Fitting",
          "description": "Precision granite slab cutting and installation"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Bathroom Renovation",
          "description": "Complete bathroom renovation with tiles and fixtures"
        }
      }
    ]
  }
};
